import { useEffect } from "react";
import SliderHome from "../components/HomeSlide/SliderHome";
import Product from "../components/products/Product";
import RumiProp from "../components/property/Property";
import KolsCarousel from "../components/KOL/Kol";
import NewsCarousel from "../components/News/News";
import CertificatesCarousel from "../components/Cer/Certificate";

function HomePage() {
  useEffect(() => {
    document.title = "Rumi Việt Nam";
  }, []);

  return (
    <div>
      <SliderHome />
      <RumiProp />
      <Product />
      <KolsCarousel />
      <NewsCarousel />
      <CertificatesCarousel />
    </div>
  );
}

export default HomePage;
